






























































import Vue from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import PaymentStatusChip from "@/components/Common/PaymentStatusChip.vue";
import PaymentMethodSelector from "@/components/PaymentMethodSelector.vue";
import CardPaymentInput from "@/components/CardPaymentInput.vue";
import { isSuccessfulResponse } from "@/services/util.service";
import { AxiosResponse } from "axios";
import Stripe from "stripe";
import config from "@/configs";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
  components: {
    PaymentStatusChip,
    PaymentMethodSelector,
    CardPaymentInput,
  },
  name: "PaymentIntentDetailsCard",
  props: {
    paymentId: {
      type: String,
      required: true,
    },
    customerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showCardInput: false,
      cardSelectedId: undefined,
    };
  },
  computed: {
    ...mapGetters("paymentIntent", [
      "getPaymentIntents",
      "getUpdatePaymentIntentsLoading",
    ]),
    ...mapGetters("paymentMethod", ["getListPaymentMethodsLoading"]),
    payment(): any {
      return (
        this.getPaymentIntents.filter(
          (pi: any) => pi.id === this.paymentId
        )[0] || {}
      );
    },
    showPaymentInfo(): boolean {
      return (
        this.payment.status === "succeeded" ||
        this.payment.status === "processing"
      );
    },
    paymentInfo(): TranslateResult {
      const sourceInfo =
        this.payment.payment_method?.card ||
        this.payment.payment_method?.us_bank_account ||
        this.payment.source;
      const sourceName =
        sourceInfo.brand ||
        sourceInfo.bank_name ||
        sourceInfo.card?.brand ||
        "----";
      const last4 = sourceInfo.last4 || sourceInfo.card?.last4 || "----";

      return `${sourceName} **** ${last4}`;
    },
  },
  methods: {
    ...mapActions("paymentIntent", ["confirmPaymentIntent"]),
    ...mapMutations("snackbar", ["toastError"]),
    onCardSelected(cardSelected: any): void {
      this.showCardInput = cardSelected === "newCard";
      this.cardSelectedId = cardSelected;
    },
    submit(): void {
      const payload = {
        id: this.paymentId,
        payment_method: this.cardSelectedId,
        capture_method: "automatic",
        return_url: config?.url?.return_url || "",
        mandate_data: {
          customer_acceptance: {
            type: "offline",
            accepted_at: Date.now(),
          },
        },
      } as Stripe.PaymentIntentCaptureParams;
      this.confirmPaymentIntent(payload).then((response: AxiosResponse) => {
        if (isSuccessfulResponse(response)) {
          this.onPaymentSuccess();
        } else {
          this.toastError({ message: response.data.error });
        }
      });
    },
    onPaymentSuccess(): void {
      this.$emit("paymentSuccess");
    },
  },
});
